import * as React from 'react';
type Props = {
  className?: string;
};
export function Plus({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-plus"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 5V11H19V13H13V19H11V13H5V11H11V5H13Z"
        fill="currentColor"
      />
    </svg>
  );
}
